import { createSelector } from 'reselect'
import { IssuerListModel, IssuerListResponse } from 'src/models/issuer.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectIssuerListResponsesFromState = (
  state: RootState,
): Record<string, IssuerListResponse> => state.data.issuers.listResponses

export const selectIssuerListModelsFromState = createSelector(
  [selectIssuerListResponsesFromState],
  (issuerListResponses) =>
    Object.values(issuerListResponses).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new IssuerListModel(curr),
      }),
      {} as Record<string, IssuerListModel>,
    ),
)
